import PropTypes from "prop-types"
import {
    TextField,
    InputAdornment,
    Button
} from "@mui/material"
import { History, Search, KeyboardBackspace } from "@mui/icons-material"
import LoadingSpinner from "../../../animation/LoadingSpinner"
import { H5, Body2, Body1 } from "../../../themes/typography"

export default function RecentScans({
    onBack = () => { },
    onSearch = () => { },
    data = [],
    loading
}) {

    return (
        <div className="recent-scans-main-container">
            <div className="attendance-taking-back-btn">
                <Button
                    variant="text"
                    onClick={onBack}
                    startIcon={<KeyboardBackspace />}
                    disableTouchRipple
                    sx={{ padding: '0', color: 'var(--quaternary-color)' }}
                >
                    Back
                </Button>
            </div>

            <div className="attendance-taking-person">
                <History color="tertiary" />
                <H5>
                    Your recent history
                </H5>
            </div>

            <TextField
                placeholder="Search by ticket ID"
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-input': {
                        padding: '14px 14px 14px 0px',
                    }
                }}
                slotProps={{ input: { startAdornment: <SearchIcon /> } }}
                onChange={(e) => onSearch(e)}
            />

            <ul className="recent-scans-list-container">

                {loading ? (
                    <li
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "20px 0",
                        }}
                    >
                        <LoadingSpinner message="Loading recent scans..." />
                    </li>
                ) : data.length === 0 ? (
                    <li>
                        <Body1>No recent scans found.</Body1>
                    </li>
                ) : (
                    data.map((item) => (
                        <li key={item.id}>
                            <div className="recent-scan-item">
                                <div className="recent-scan-item-info">
                                    <Body2 fontWeight={500}>
                                        {item.ticket_name}
                                    </Body2>
                                    <Body2 fontWeight={300}>
                                        {item.ticket_number}
                                    </Body2>
                                </div>

                                <div className="recent-scan-item-action">
                                    <Body2 fontWeight={500} color={item.action === "checked_in" ? "var(--success-main-color)" : "var(--error-main-color)"}>
                                        {item.action === "checked_in" ? "Checked In" : "Rejected"}
                                    </Body2>
                                    <Body2 fontWeight={300}>
                                        {item.action_time}
                                    </Body2>
                                </div>
                            </div>
                        </li>
                    ))
                )}

            </ul>

        </div>
    )
}

function SearchIcon() {
    return (
        <InputAdornment position="start">
            <Search sx={{ color: 'var(--quaternary-color)' }} />
        </InputAdornment>
    );
}

RecentScans.propTypes = {
    onBack: PropTypes.func,
    onSearch: PropTypes.func,
    data: PropTypes.array,
    loading: PropTypes.bool
};